<template>
  <div class="vacancy-edit-media">
    <h3 class="vacancy-edit-media__title">{{$tNewVacancy('Add photo / video')}}</h3>
    <div :class="!images.length ? '_empty' : null"
         class="vacancy-edit-media__content">
      <div class="vacancy-edit-media__carousel">
        <div class="vacancy-edit-media__carousel-wrap" ref="edit-carousel">
          <div class="vacancy-edit-media__list">
            <div class="vacancy-edit-media__slide"
                 v-for="item in images"
                 :key="item.id"
            >
              <video v-if="isVideo(item)"
                     controls
                     class="vacancy-edit-media__slide-img">
                <source :src="item.path" :type="item.type">
                Your browser does not support the video tag.
              </video>
              <img v-else
                   :src="item.path"
                   alt="vacancy-img"
                   class="vacancy-edit-media__slide-img">
            </div>
          </div>
        </div>
        <button ref="prev" class="vacancy-edit-media__nav  _prev  base-btn  base-btn--grey-blue">
          <BaseSvg name="ico-arrow-light"/>
        </button>
        <button ref="next" class="vacancy-edit-media__nav  _next  base-btn  base-btn--grey-blue">
          <BaseSvg name="ico-arrow-light"/>
        </button>
        <div class="vacancy-edit-media__add">
          <input type="file"
                 multiple
                 @input="onFilesInputMixin">

          <span class="vacancy-edit-media__add-btn">
            <BaseSvg name="ico-plus"/>
            <span>{{$tNewVacancy('Add')}}</span>
          </span>

        </div>
        <button v-if="images.length"
                type="button"
                @click.prevent="onDeleteFile"
                class="vacancy-edit-media__btn-remove base-btn">
          <BaseSvg name="ico-close"/>
        </button>
      </div>
      <div v-if="images.length"
           class="vacancy-edit-media__description-wrap">
        <div v-for="(item, index) in images"
             :key="index"
             v-show="index === activeSlide"
             class="vacancy-edit-media__description">
          <div class="vacancy-edit-media__description-top">
            <BaseSelect :label="$tNewVacancy('Gallery position')"
                        :value="index + 1"
                        :options="positions"
                        @input="onChangePosition(index, $event - 1)"
                        class="vacancy-edit-media__position-select _white _shadow-full"
            />

            <div class="vacancy-edit-media__radio"
                 :class="coverIndex === index ? '_checked' : null"
                 @click.prevent="onCheckCover(index)"
            >
              <div class="vacancy-edit-media__radio-label">{{$tNewVacancy('Set as cover')}}</div>
              <span class="vacancy-edit-media__radio-mark">
                <BaseSvg name="ico-tick"/>
              </span>
            </div>
          </div>
          <BaseInput :label="$tNewVacancy('Snap link')"
                     :value="item.link"
                     @input="onLinkInput(index, $event)"
                     class="vacancy-edit-media__link-input _white _shadow"
          />

          <button v-if="item.description === null"
                  @click.prevent="onAddComment(index)"
                  class="vacancy-edit-media__add-comment base-btn base-btn--outline-grey">
            <span>{{$tNewVacancy('Add a comment to the slide')}}</span>
          </button>

          <TranslateFiled
            v-else
            :label="$tNewVacancy('Comment')"
            textarea
            :value="item.description"
            withFullDelete
            @input="onCommentInput(index, $event)"
            @delete="onDeleteComment(index)"
            class="vacancy-edit-media__comment"
          />
        </div>
      </div>
    </div>
    <BaseAlert :value="errorMixin" class="_error"/>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Swiper from "swiper";
  import TranslateFiled from './TranslateFiled'
  import fileUploadMixin from '../mixins/fileUploadMixin'
  import {
    VIDEOS_MIME_TYPES,
    IMAGES_MIME_TYPES,
    ALLOWED_IMAGES_EXTS,
    ALLOWED_VIDEOS_EXTS
  } from '../constants/files'

  export default {
    name: "VacancyEditMedia",
    mixins: [fileUploadMixin],
    components: {
      TranslateFiled
    },
    data() {
      return {
        swiper: null,
        activeSlide: 0,
        dragoverMixin: false,
        errorMixin: null,
        uploadFileMethodNameMixin: ['uploadFile'],
        allowedFilesExtsMixin: [...ALLOWED_IMAGES_EXTS, ...ALLOWED_VIDEOS_EXTS],
        allowedFilesMimeTypes: [...IMAGES_MIME_TYPES, ...VIDEOS_MIME_TYPES]
      }
    },
    computed: {
      ...mapState('vacancyEdit/images', [
        'muted',
        'pendingUpload',
        'filesToUpload',
        'filesUploaded',
        'coverIndex',
      ]),
      vacancyId() {
        return this.$route.params.vacancyId
      },
      images() {
        return this.vacancyId ? this.filesUploaded : this.filesToUpload
      },
      positions() {
        const positions = []

        for (let i = 0; i < this.images.length; i++) {
          positions.push(i + 1)
        }

        return positions
      }
    },
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['edit-carousel'], {
          wrapperClass: 'vacancy-edit-media__list',
          slideClass: 'vacancy-edit-media__slide',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          navigation: {
            prevEl: this.$refs['prev'],
            nextEl: this.$refs['next'],
            disabledClass: '_disabled',
            hiddenClass: '_hidden',
            lockClass: '_hidden'
          }
        })
      },
      onCheckCover(index) {
        this.onChangePosition(index, 0)
        this.$store.commit('vacancyEdit/images/setCoverIndex', 0)
      },
      checkActiveSlide() {
        this.activeSlide = this.swiper.activeIndex
      },

      uploadFile(files) {
        this.$store.commit('vacancyEdit/images/addFilesToUpload', files)
        if (this.$route.params.vacancyId) {
          this.$store.dispatch('vacancyEdit/images/upload', this.$route.params.vacancyId)
        }
      },
      onDeleteFile() {
        if (this.vacancyId) {
          const data = {
            vacancyId: this.vacancyId,
            index: this.activeSlide,
            id: this.images[this.activeSlide].id
          }
          this.$store.dispatch('vacancyEdit/images/deleteFileUploaded', data)
        } else {
          this.$store.commit('vacancyEdit/images/deleteFileToUpload', this.activeSlide)
        }
      },
      deleteFileUploaded(index, id) {
        if (!this.vacancyId) return
        this.$store.dispatch('vacancyEdit/images/deleteFileUploaded', {
          vacancyId: this.vacancyId,
          index,
          id
        })
      },
      onCommentInput(index, comment) {
        if (this.vacancyId) {
          this.$store.commit('vacancyEdit/images/setCommentFilesUploaded', {index, comment})
        } else {
          this.$store.commit('vacancyEdit/images/setCommentFilesToUpload', {index, comment})
        }
      },
      onLinkInput(index, link) {
        if (this.vacancyId) {
          this.$store.commit('vacancyEdit/images/setLinkFilesUploaded', {index, link})
        } else {
          this.$store.commit('vacancyEdit/images/setLinkFilesToUpload', {index, link})
        }
      },
      onAddComment(index) {
        if (this.vacancyId) {
          this.$store.commit('vacancyEdit/images/setCommentFilesUploaded', {index, comment: ''})
        } else {
          this.$store.commit('vacancyEdit/images/setCommentFilesToUpload', {index, comment: ''})
        }
      },
      onDeleteComment(index) {
        if (this.vacancyId) {
          this.$store.commit('vacancyEdit/images/setCommentFilesUploaded', {index, comment: null})
        } else {
          this.$store.commit('vacancyEdit/images/setCommentFilesToUpload', {index, comment: null})
        }
      },
      onChangePosition(index, position) {
        if (isNaN(position)) return

        if (this.vacancyId) {
          this.$store.commit('vacancyEdit/images/changePositionFilesUploaded', {index, position})
        } else {
          this.$store.commit('vacancyEdit/images/changePositionFilesToUpload', {index, position})
        }

        this.swiper.slideTo(position, 600);
      },
      isVideo(file) {
        return VIDEOS_MIME_TYPES.includes(file.type)
      }
    },
    mounted() {
      this.createSwiper()
      this.swiper.on('init slideChange', this.checkActiveSlide)
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }
</script>

<style>

</style>
